// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { Record, List } from "immutable"

import MultiPlace from "./MultiPlace"
import { createAnytime, createTimeToStay } from "./SearchDate/utils"
import type { DateRange, Anytime, TimeToStay } from "./SearchDate/SearchDate"
import type { Plain } from "./SearchPlace"
import SearchPlace from "./SearchPlace"

const SalesmanFormDataRecord = Record({
  dateRangeEnabled: true,
  timeOfStayEnabled: true,
  dateRange: createAnytime(true),
  timeOfStay: createTimeToStay(3, 5, true),
  destination: new MultiPlace({
    places: List([new SearchPlace({ mode: "anywhere", isDefault: true })]),
  }),
})

export default class SalesmanFormData extends SalesmanFormDataRecord {
  // @ts-expect-error: Flow to TS migration.
  dateRange: DateRange | Anytime

  // @ts-expect-error: Flow to TS migration.
  timeOfStay: TimeToStay

  // @ts-expect-error: Flow to TS migration.
  destination: MultiPlace

  // @ts-expect-error: Flow to TS migration.
  dateRangeEnabled: boolean

  // @ts-expect-error: Flow to TS migration.
  timeOfStayEnabled: boolean

  static fromPlainJS(plain: Plain): SalesmanFormData {
    return new SalesmanFormData({
      ...plain,
      // @ts-expect-error: Flow to TS migration.
      destination: MultiPlace.fromPlainJS(plain.destination),
      // @ts-expect-error: Flow to TS migration.
      dateRange: plain.dateRange,
    })
  }
}
